import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TsPieceComponent } from '../shared/ts-piece/ts-piece.component';
import { PROJECTS, Project } from '../proyecto-detalle/projects.data';

/**
 * "Desarrollos a medida" (`/a-medida`) — portfolio de casos reales (sustituye a
 * /proyectos). Parrilla filtrable por tipo de desarrollo, servida desde
 * `projects.data.ts`. Cada tarjeta lleva a su ficha `/a-medida/:slug`.
 */
@Component({
  selector: 'app-a-medida',
  standalone: true,
  imports: [RouterLink, TsPieceComponent],
  templateUrl: './a-medida.component.html',
  styleUrl: './a-medida.component.scss',
})
export class AMedidaComponent {
  readonly projects = PROJECTS;
  /** Tipos de desarrollo para los chips de filtro ("Todos" + los del catálogo). */
  readonly tipos = ['Todos', ...Array.from(new Set(PROJECTS.map(p => p.tipo)))];
  activeTipo = 'Todos';

  get filtered(): Project[] {
    return this.activeTipo === 'Todos'
      ? this.projects
      : this.projects.filter(p => p.tipo === this.activeTipo);
  }

  setTipo(tipo: string): void {
    this.activeTipo = tipo;
  }
}
